export enum EAggregators {
  CREDIT_KARMA = "CreditKarma",
  CREDIT_KARMA_STORE_CARD = "CreditKarmaStoreCard",
  CLEARSCORE = "Clearscore",
  CLEARSCORE_STORE_CARD = "ClearscoreStoreCard",
  TOTALLY_MONEY = "TotallyMoney",
  TOTALLY_MONEY_STORE_CARD = "TotallyMoneyStoreCard",
  MONEY_SUPERMARKET = "MoneySupermarket",
  VANQUIS = "Vanquis",
  MONEVO = "Monevo",
  TUK = "Tuk",
  CREDITEC = "Creditec",
  INFLUENCER_1 = "Influencer1",
  INFLUENCER_2 = "Influencer2",
  INFLUENCER_3 = "Influencer3",
  INFLUENCER_4 = "Influencer4",
  INFLUENCER_5 = "Influencer5",
  INFLUENCER_6 = "Influencer6",
  INFLUENCER_7 = "Influencer7",
  INFLUENCER_8 = "Influencer8",
  INFLUENCER_9 = "Influencer9",
  INFLUENCER_10 = "Influencer10",
}

export const buildBitsUniversalLink = (aggregator: string, aggregatorUid: string) => {
  if (!process.env.REACT_APP_BITS_BASE_UNIVERSAL_LINK) {
    return "";
  }
  return `${process.env.REACT_APP_BITS_BASE_UNIVERSAL_LINK}?aggregator=${aggregator}&aggregatorUid=${aggregatorUid}`;
};
